<!-- Floating Action Button -->
<div 
  class="chat-fab" 
  cdkDrag
  cdkDragLockAxis="y"
  [class.fab-hidden]="chatbotService.isOpen"
  (click)="openChatbot()">
  <i class="fa-solid fa-comments"></i>
</div>

<div
  class="chat-container"
  [style.width.px]="chatWidth"
  [style.height.px]="chatHeight"
  [ngClass]="{
    'chat-open': chatbotService.isOpen,
    'chat-closed': !chatbotService.isOpen
  }"
  >
  <!-- Custom Top-Left Resize Handle (Top-Left because when anchored to bottom-right, pulling Top-Left expands it up and left) -->
  <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>
  
  <!-- Chat header with clear button -->
  <div class="chat-header">
    <span>Support Chat</span>
    <div class="header-actions">
      <!-- Clear conversation button - only show when chat is open and has messages -->
      @if (chatbotService.isOpen && chatbotService.messages.length > 0) {
        <button
          (click)="clearConversation(); $event.stopPropagation()"
          class="clear-btn"
          title="Clear conversation"
          >
          <i class="fa-solid fa-pen-to-square"
          style="color: black"></i>
        </button>
      }
      <!-- Speaker Toggle -->
      <button
        (click)="toggleVoiceOutput(); $event.stopPropagation()"
        class="header-btn toggle-btn"
        [class.active]="chatbotService.isVoiceOutputEnabled"
        title="Toggle Speaker (TTS)"
      >
        <i class="fa-solid" [ngClass]="chatbotService.isVoiceOutputEnabled ? 'fa-volume-high' : 'fa-volume-xmark'"></i>
      </button>

      <!-- Microphone Toggle -->
      <button
        (click)="toggleVoiceInput(); $event.stopPropagation()"
        class="header-btn toggle-btn"
        [class.active]="chatbotService.isVoiceInputEnabled"
        title="Toggle Microphone (STT)"
      >
        <i class="fa-solid" [ngClass]="chatbotService.isVoiceInputEnabled ? 'fa-microphone' : 'fa-microphone-slash'"></i>
      </button>

      <!-- Toggle button -->
      <span
        class="toggle-icon"
        (click)="chatbotService.isOpen ? closeChatbot() : openChatbot()"
        >
        {{ chatbotService.isOpen ? "−" : "+" }}
      </span>
    </div>
  </div>

  <!-- Chat content -->
  @if (chatbotService.isOpen) {
    <div class="chat-content">
      <!-- Messages -->
      <div class="messages-container" #messagesContainer>
        @for (message of chatbotService.messages; track message) {
          <div
            class="message"
        [ngClass]="{
          'user-message': message.isUser,
          'bot-message': !message.isUser
        }"
            >
            <div class="message-content html-content" [innerHTML]="message.text"></div>
            <!-- Source indicator for FAQ responses -->
            @if (message.source === 'local') {
              <div class="source-tag">
                From FAQ
              </div>
            }
          </div>
        }
        @if (chatbotService.isTyping) {
          <div class="message bot-message typing-indicator">
            <div class="message-content">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }
      </div>
      <!-- Input area -->
      <div class="input-container">
        <textarea
          [(ngModel)]="chatbotService.userInput"
          (keydown.enter)="sendMessage(); $event.preventDefault()"
          placeholder="Type your message..."
          class="message-input"
          spellcheck="true"
          autocorrect="on"
          rows="1"
          style="resize: none; overflow: hidden; padding-top: 11px; padding-bottom: 11px; height: 44px; box-sizing: border-box;"
          ></textarea>
          
          @if (chatbotService.isVoiceInputEnabled) {
            <button 
              (click)="toggleRecording()" 
              class="mic-button" 
              [class.recording]="isRecording"
              title="Hold to speak or click to toggle">
              <i class="fa-solid fa-microphone"></i>
            </button>
          }

          <button (click)="sendMessage()" class="send-button">Send</button>
        </div>
      </div>
    }
  </div>
